/*=========================================================================================
  File Name: moduleUserFileMutations.js
  Description: UserFile Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

    SET_USER_FILE(state, data) {
        state.userFileList = data.resultBody
        state.userFileListCount = data.resultCount
    },
    SET_FILE_DOWNLOAD_HISTORY(state, data) {
        state.fileDownloadHistoryList = data.resultBody
        state.fileDownloadHistoryCount = data.resultCount
    },
    SET_FILE_RECV_HISTORY(state, data) {
        state.fileRecvHistoryList = data.resultBody
        state.fileRecvHistoryCount = data.resultCount
    }
}